import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('public.data-deletion-form', {
        url: '/data-deletion',
        component: 'dataDeletionForm',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/public/data-deletion-form/data-deletion-form.state.js